module.exports = __webpack_public_path__ + "static/media/Resources.4be18823.svg";